/* BarkBark AJAX cart - native Shopify Cart API (/cart/add.js, /cart/change.js, /cart.js) */
(() => {
  const drawer = () => document.getElementById('BbCartDrawer');
  const veil = () => document.getElementById('BbCartVeil');
  // Formats cents using the shop's own money format (correct currency,
  // symbol, separators). Falls back to $ only if the format is missing.
  function delims(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
  }
  function money(cents) {
    var format = window.BbMoneyFormat || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount':
        value = delims(cents, 2);
        break;
      case 'amount_no_decimals':
        value = delims(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = delims(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = delims(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = delims(cents, 2, ' ', '.');
        break;
      default:
        value = delims(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  function openCart() {
    drawer()?.classList.add('is-open');
    veil()?.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    drawer()?.classList.remove('is-open');
    veil()?.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      const countEls = document.querySelectorAll('[data-bb-cart-count]');
      countEls.forEach((el) => {
        el.textContent = cart.item_count > 0 ? cart.item_count : '';
        el.hidden = cart.item_count === 0;
      });
      const itemsEl = document.getElementById('BbCartItems');
      const footEl = document.getElementById('BbCartFoot');
      const subEl = document.getElementById('BbCartSubtotal');
      if (!itemsEl) return;
      if (!cart.items.length) {
        itemsEl.innerHTML = `<p style="color:#64748b;padding:24px 0;text-align:center">Your cart is empty.<br>Your pup deserves dry floors.</p>`;
        if (footEl) footEl.style.display = 'none';
        return;
      }
      if (footEl) footEl.style.display = '';
      itemsEl.innerHTML = cart.items
        .map(
          (it) => `
          <div class="bb-cart-item" data-key="${it.key}">
            <img src="${it.image}" alt="" loading="lazy">
            <div style="flex:1">
              <div style="font-weight:700;font-size:14px">${it.product_title}</div>
              <div style="color:#64748b;font-size:13px">${it.variant_title || ''}</div>
              <div style="display:flex;align-items:center;justify-content:space-between;margin-top:8px">
                <span class="bb-qty">
                  <button data-bb-dec="${it.key}" aria-label="Decrease">−</button>
                  <span style="min-width:24px;text-align:center;font-weight:700">${it.quantity}</span>
                  <button data-bb-inc="${it.key}" aria-label="Increase">+</button>
                </span>
                <strong>${money(it.final_line_price)}</strong>
              </div>
              <button data-bb-remove="${it.key}" style="border:0;background:none;color:#64748b;font-size:12px;cursor:pointer;padding:4px 0;text-decoration:underline">Remove</button>
            </div>
          </div>`
        )
        .join('');
      if (subEl) subEl.textContent = money(cart.total_price);
    } catch (e) {
      console.error('[barkbark] cart refresh failed', e);
    }
  }

  async function changeQty(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    await refreshCart();
  }

  document.addEventListener('click', async (e) => {
    const openBtn = e.target.closest('[data-bb-open-cart]');
    if (openBtn) {
      e.preventDefault();
      await refreshCart();
      openCart();
      return;
    }
    if (e.target.closest('[data-bb-close-cart]') || e.target === veil()) {
      closeCart();
      return;
    }
    const inc = e.target.closest('[data-bb-inc]');
    const dec = e.target.closest('[data-bb-dec]');
    const rem = e.target.closest('[data-bb-remove]');
    if (inc) {
      const row = inc.closest('.bb-cart-item');
      const qty = parseInt(row.querySelector('.bb-qty span').textContent, 10) || 1;
      await changeQty(inc.getAttribute('data-bb-inc'), qty + 1);
    }
    if (dec) {
      const row = dec.closest('.bb-cart-item');
      const qty = parseInt(row.querySelector('.bb-qty span').textContent, 10) || 1;
      await changeQty(dec.getAttribute('data-bb-dec'), Math.max(0, qty - 1));
    }
    if (rem) await changeQty(rem.getAttribute('data-bb-remove'), 0);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  // Product form AJAX submit - hooked by main-product section via data-bb-product-form
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-bb-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-bb-add]');
    const original = btn ? btn.innerHTML : '';
    try {
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = 'Adding…';
      }
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd,
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart');
      }
      await refreshCart();
      openCart();
    } catch (err) {
      alert(err.message);
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = original;
      }
    }
  });

  document.addEventListener('DOMContentLoaded', refreshCart);
})();
